import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { bloqueioService } from "../services/bloqueio-service";
import { BloquearParams, BloqueioFiltros, DesbloquearParams } from "../types";

export const bloqueioKeys = {
  all: ["bloqueio"] as const,
  opcoes: () => [...bloqueioKeys.all, "opcoes"] as const,
  lista: (filtros: BloqueioFiltros, page: number) =>
    [...bloqueioKeys.all, "lista", filtros, page] as const,
};

export const mensagemErro = (error: any) =>
  error?.response?.data?.message || error?.message || "Erro inesperado.";

// Motivos do gestor e ops com cadastro, para os selects e filtros.
export function useOpcoesBloqueio() {
  return useQuery({
    queryKey: bloqueioKeys.opcoes(),
    queryFn: async () => (await bloqueioService.opcoes()).data,
    staleTime: Infinity,
  });
}

export function useListaBloqueios(
  filtros: BloqueioFiltros,
  page: number,
  pageSize = 50,
) {
  return useQuery({
    queryKey: bloqueioKeys.lista(filtros, page),
    queryFn: async () =>
      (await bloqueioService.listar({ filtros, page, pageSize })).data,
    placeholderData: keepPreviousData,
  });
}

// Depois de bloquear/desbloquear, a lista e a busca de cadastros ficam velhas:
// invalida a lista aqui e deixa `onDone` atualizar a busca da aba Cadastros.
export function useBloqueioMutations(onDone?: () => void) {
  const queryClient = useQueryClient();
  const aposMudar = () => {
    queryClient.invalidateQueries({ queryKey: [...bloqueioKeys.all, "lista"] });
    onDone?.();
  };

  const bloquear = useMutation({
    mutationFn: async (params: BloquearParams) =>
      (await bloqueioService.bloquear(params)).data,
    onSuccess: aposMudar,
  });
  const desbloquear = useMutation({
    mutationFn: async (params: DesbloquearParams) =>
      (await bloqueioService.desbloquear(params)).data,
    onSuccess: aposMudar,
  });
  return { bloquear, desbloquear };
}
